import * as types from './types';
import * as settings from '../settings';

export const fetchTrackers = () => dispatch => {
  console.log('actions::api::fetchTrackers');
  fetch(settings.SERVICE_API_URL + '/v1/account/trackers', {
      headers: {
        'X-Session': settings.USER_SESSION,
      }
    })
    .then(res => res.json())
    .then(json => {
      dispatch({type: types.UPDATE_TRACKERS, trackers: json.items});
      if (json.items.length > 0) {
        dispatch({type: types.CHANGE_TRACKER, tracker: json.items[0].id});
      }
    })
    .catch(err => {
      console.error(err);
    })
};

export const fetchTrackerReports = id => dispatch => {
  console.log('actions::api::fetchTrackerReports');
  fetch(settings.SERVICE_API_URL + '/v1/account/trackers/' + id + '/reports', {
      headers: {
        'X-Session': settings.USER_SESSION,
      }
    })
    .then(res => res.json())
    .then(json => {
      dispatch({type: types.UPDATE_REPORTS, reports: json.reports});
      if (json.reports.length > 0) {
        const { longitude, latitude } = json.reports[0];
        dispatch({type: types.CHANGE_MAP_CENTER, longitude, latitude});
      }
    })
    .catch(err => {
      console.error(err);
    })
};
